import { routing, usePathname, useRouter } from '@/i18n/routing'
import { Globe } from 'lucide-react'
import { Locale, useLocale } from 'next-intl'
import { useParams, useSearchParams } from 'next/navigation'
import { useTransition } from 'react'
import * as CookieConsent from 'vanilla-cookieconsent'

const changeCookieLanguage = (lang: Locale) => {
  CookieConsent.reset()
  CookieConsent.setLanguage(lang)
}

const locales = routing.locales

const NamedLocales: Record<Locale, string> = {
  'en-US': 'English',
  'es-AR': 'Español',
  'fr-FR': 'Français',
  'ko-KR': '한국어',
  'zh-CN': '简体中文',
}

const availableLocales = locales.map((locale) => ({
  value: locale,
  label: NamedLocales[locale],
}))

export function useLocaleControl() {
  const router = useRouter()
  const currentLocale = useLocale()
  const [isPending, startTransition] = useTransition()
  const pathname = usePathname()
  const params = useParams()
  const searchParams = useSearchParams()

  const setLocale = (lang: Locale) => {
    startTransition(() => {
      const query = Object.fromEntries(searchParams.entries())
      router.replace(
        // @ts-expect-error -- TypeScript will validate that only known `params`
        // are used in combination with a given `pathname`. Since the two will
        // always match for the current route, we can skip runtime checks.
        { pathname, params, query },
        { locale: lang },
      )
      changeCookieLanguage(lang)
    })
  }

  return {
    currentLocale,
    setLocale,
    availableLocales,
    isPending,
    LanguageIcon: Globe,
  }
}
